import useFilterParams from "catalog/hooks/useFilterParams";
import { buildFilterMatrix, INDICES } from "catalog/utils/buildFilterMatrix";
import queryString from "query-string";
import { useDebounce } from "~/hooks/useDebounce";
import { useFetcher } from "~/hooks/useFetcher";
import SearchResponse from "~/types/interfaces/catalogResponse";

const { VITE_CATALOG_API } = import.meta.env;

/**
 * Get all filter facets to display in UI
 */
const useFilterFacets = (entityType: "table" | "column", enabled: boolean) => {
  const [params] = useFilterParams();
  const { q: search, ttags = [], ctags = [] } = params;
  const debouncedSearch = useDebounce(search);
  const filters = buildFilterMatrix((entityType === "table" ? ttags : ctags) as string[]);

  const qs = queryString.stringify({
    index: INDICES[entityType],
    q: debouncedSearch,
    query_filter: JSON.stringify(filters),
    size: 0,
  });

  return useFetcher<SearchResponse>(enabled ? `${VITE_CATALOG_API}/search/query?${qs}` : null);
};

export default useFilterFacets;
